import React from 'react'

import {
    GalleryPublicationInformation,
    RemainingPublicationInformation,
} from 'component-library/templates/Publication/SharedPublication.routing'
import { AdState } from 'common/advertising/ad-state'
import { Gallery } from 'component-library/content/Gallery/Gallery'
import { GalleryEvent } from 'common/events/publication-events'
import { AdEvent } from 'common/events/viewability-event'
import { AdUnitWrapper } from 'component-library/advertising/AdUnit/AdUnitWrapper'

export const renderPublicationSkeleton = (
    componentMeta: GalleryPublicationInformation | RemainingPublicationInformation,
    ads: AdState,
    onEvent: (event: GalleryEvent | AdEvent) => void
) => {
    if (componentMeta.kind === 'gallery') {
        return (
            <Gallery
                loading
                adFrequency={3}
                ads={componentMeta.galleryAds.map(ad => (
                    <AdUnitWrapper
                        hiddenUntilLoaded={ad.hiddenUntilLoaded}
                        noticePosition={ad.noticePosition}
                        padding={ad.padding}
                        adState={ads}
                        unitId={ad.slot.id}
                        onEvent={onEvent}
                    />
                ))}
                onEvent={onEvent}
            />
        )
    }

    // TODO Publication Skeleton
    return null
}
